<app-grid
[columns]="columns"
[rows]="data.tableRows"
[tableParams]="data.tableParams"
[multiSelect]="false"
[gridName]="gridName"
[allowCopy]="false"
[allowDelete]="false"
[allowView]="false"
[allowAdd]="!selectedQuestionBank.isPsychometricTestBank"
[allowEdit]="!selectedQuestionBank.isPsychometricTestBank"
(refreshDataFromServer)="refreshData($event)"
(rowSelected)="rowSelectedEvent($event)"
(addClicked)="addQuestion()"
(editClicked)="editQuestion($event)">
</app-grid>